// Class: haxe._Int64.___Int64

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var ___Int64 = function(high,low) {
	this.high = high;
	this.low = low;
}

// Meta

___Int64.__name__ = "haxe._Int64.___Int64";
___Int64.__isInterface__ = false;
___Int64.prototype = {
	
};
___Int64.prototype.__class__ = ___Int64.prototype.constructor = $hxClasses["haxe._Int64.___Int64"] = ___Int64;

// Init



// Statics




// Export

exports.default = ___Int64;